import requestStatus from '../../constants/requestStatus'
import ButtonSubmit from './ButtonSubmit'
import { AUTH_CAPS } from '../../constants/state'
import { connect } from 'react-redux'
import toJS from '../../containers/general/toJS'
import { EDIT_PROGRAM_CAP } from '../../constants/caps'
import hasCap from '../../functions/hasCap'
import getData from '../../functions/getData'

const mapStateToProps = state => ({
    caps: getData(state, AUTH_CAPS)
})

const SaveStateButton = ({status, transId, condition=true, saveState, cap=EDIT_PROGRAM_CAP, caps}) => {    
    let translationId
    const { REQUEST_PENDING, REQUEST_ERROR } = requestStatus
    const disablePermanently = !hasCap(caps, cap)

    if(condition && REQUEST_PENDING === status ) {
        translationId = "button_status_will_saved"
    } else if(condition && REQUEST_ERROR === status) {
        translationId  = "button_status_error"
    } else {
        translationId  = transId
    }

    return (
        <ButtonSubmit
            transIdSubmit={translationId}
            onSubmit={saveState}
            disableTemporarily={false}
            disablePermanently={disablePermanently}
        />
    )
}

export default connect(mapStateToProps)(toJS(SaveStateButton))